module.exports = __webpack_public_path__ + "img/Engie_120X35.3612d7f9.png";